import React from 'react'
import AccountCircleIcon from '@material-ui/icons/AccountCircleRounded';
import ListIcon from '@material-ui/icons/List';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import Drawer from '@material-ui/core/Drawer';
import Navigation from '../Navigation'
import { Link } from "react-router-dom";
import { withStyles } from '@material-ui/styles';
import CurrentUserProfilePic from '../CurrentUserProfilePic'
import authStore from '../../authStore'
import { withRouter } from 'react-router-dom'

const classes = {
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '1rem 13px',
        '&>div': {
            alignSelf: 'center',
            fontSize: '1.7rem'
        }
    },
    list: {
        width: 250,
    },
    fullList: {
        width: 'auto',
    },
};

class Header extends React.Component {
    constructor() {
        super()
        this.state = {
            right: false,
            slogen: 'נביא שקית ונשאיר נקי'
        }
    }

    toggleDrawer(open) {
        this.setState({ right: open });
    };

    render() {
        const { pathname } = this.props.location;
        const { classes } = this.props;
        const loggedIn = authStore.loggedIn

        return (
            <div id='header' className={classes.header} >
                <div style={{ flex: 1, textAlign: 'right' }}>

                    <MoreVertIcon onClick={function () { this.toggleDrawer(true) }.bind(this)} style={{ fontSize: '2.2rem' }} />
                    <Drawer anchor="right" open={this.state.right} onClose={function () { this.toggleDrawer(false) }.bind(this)}>
                        <div
                            className={classes.list}
                            role="presentation"
                            onClick={function () { this.toggleDrawer(false) }.bind(this)}
                            onKeyDown={function () { this.toggleDrawer(false) }.bind(this)}
                        >
                            <Navigation />
                        </div>
                    </Drawer>
                </div>

                <div style={{ textAlign: 'center', fontSize: '1.4rem' }}>{this.state.slogen}</div>

                <div style={{ flex: 1, textAlign: 'left', whiteSpace: 'nowrap' }}>
                    {pathname !== '/' ? 
                    <Link to="/" style={{ display: 'inline-block', verticalAlign: '0.3rem' }}>
                        <LocationOnIcon style={{ fontSize: '2.3rem' }} /></Link> :
                        <Link to="/feed" style={{ display: 'inline-block' }}>
                            <ListIcon style={{ fontSize: '2.7rem' }} /></Link>}

                    <Link to="/profile" style={{ display: 'inline-block', marginRight: '5px' }}>
                        {loggedIn ?
                            <CurrentUserProfilePic showScore={true} height="3.3rem" /> :
                            <AccountCircleIcon fontSize="large" />}
                    </Link>
                </div>
            </div>
        )
    }
}

const RoutedHeader = withRouter(props => <Header {...props} />);

export default withStyles(classes)(RoutedHeader);